export default __webpack_public_path__ + "static/media/streamer_avatar16.70bf7d82.png";